// Types
import { TChipColor, TChipProps, TChipSize, TChipVariant } from './Chip.type';

export const CHIP_COLORS: TChipColor[] = ['primary', 'secondary', 'tertiary', 'success', 'warning', 'error', 'information'];
export const CHIP_COLOR: { [key in TChipColor]: key } = {
	primary: 'primary',
	secondary: 'secondary',
	tertiary: 'tertiary',
	success: 'success',
	warning: 'warning',
	error: 'error',
	information: 'information',
}

export const CHIP_SIZES: TChipSize[] = ['sm', 'md', 'lg'];
export const CHIP_SIZE: { [key in TChipSize]: key } = {
	sm: 'sm',
	md: 'md',
	lg: 'lg',
}

export const CHIP_VARIANTS: TChipVariant[] = ['solid', 'soft', 'outline']
export const CHIP_VARIANT: { [key in TChipVariant]: key } = {
	solid: 'solid',
	soft: 'soft',
	outline: 'outline',
}

export const CHIP_DEFAULT_PROPS: TChipProps = {
	color: CHIP_COLOR.primary,
	size: CHIP_SIZE.md,
	variant: CHIP_VARIANT.solid,
}
